import Storage from '../../../core/storage/storage'
import Template from '../../template'
import FilmixQuality from '../../../services/filmix_quality'

export default {
    onCreate: function(){
        let data = this.data

        if(data.original_name){
            this.html.find('.card__view')?.append(Template.elem('div', {class: 'card__type', text: data.original_name ? 'TV' : 'MOV'}))
            this.html.addClass(data.original_name ? 'card--tv' : 'card--movie')
        }

        if(!Storage.field('card_quality')) return

        // На плашке показываем ТОЛЬКО наше качество — то разрешение, которое
        // реально спарсили с Filmix и отдадим зрителю. Тип релиза от CUB
        // (WEBDL/TS/CAMRip) намеренно не рисуем: он ничего не говорит о том,
        // что человек получит, нажав play.
        //
        // Ответ приходит пачкой на все видимые карточки, поэтому плашку создаём
        // в колбэке; нет фильма в нашем реестре — плашки не будет вовсе.
        FilmixQuality.get(data, (value, text)=>{
            // find() здесь возвращает сам элемент (обёртка Lampa), а не коллекцию —
            // проверять .length нельзя, её просто нет.
            let view = this.html.find('.card__view')

            if(!view) return

            view.append(Template.elem('div', {
                class: 'card__quality' + (value >= 2160 ? ' card__quality--4k' : ''),
                children: [Template.elem('div', {text: text})]
            }))
        })
    }
}
